/**
 * Public vanity-link resolver (`GET /resolveEventBySlug`).
 */
export async function fetchResolveEventBySlug({ serverUrl, slug, accountId, siteName } = {}) {
  const slugNorm = slug != null ? String(slug).trim().toLowerCase() : "";
  if (!slugNorm) {
    throw new Error("Invalid event link.");
  }
  const base = serverUrl != null ? String(serverUrl).replace(/\/$/, "") : "";
  if (!base) {
    throw new Error("Server URL is not configured.");
  }

  const params = new URLSearchParams({ slug: slugNorm });
  const site = siteName != null ? String(siteName).trim().toLowerCase() : "";
  const account = accountId != null ? String(accountId).trim() : "";
  if (site) {
    params.set("site_name", site);
  } else if (account) {
    params.set("account_id", account);
  } else {
    throw new Error("Provide account_id or site_name to resolve this event link.");
  }

  const resp = await fetch(`${base}/resolveEventBySlug?${params.toString()}`);
  const data = await resp.json().catch(() => null);
  if (!resp.ok || !data?.success) {
    throw new Error((data && data.error) || "Event not found for this URL.");
  }

  return {
    eventId: String(data.eventId),
    accountId: String(data.accountId),
    slug: data.slug,
    name: data.name || "",
    visibility: data.visibility === "private" ? "private" : "public",
    is_placeholder: Boolean(data.is_placeholder),
    status: data.status || "Open",
  };
}
